import axios from 'axios';
import { getBaseUrl } from './helpers';
import { refreshToken } from './auth';

// API Endpoints
const GET_INCIDENTS_ENDPOINT = `/alerts/api/incidents/`;
const GET_ALERTS_ENDPOINT = `/alerts/api/alerts`;
const ALERTS_FOLLOWERS_ENDPOINT = `/alerts/api/followers/`;

export const getRecentIncidents = (env, identifier) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCIDENTS_ENDPOINT}${identifier}/events/recent/`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
      building_identifier: identifier,
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getRecentIncidents(env, identifier);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const getIncidentOverview = (env, building) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/events/overview/`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getIncidentOverview(env, building);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const getIncidents = (env, building, isResolved) => { // Not used
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/?page_size=10&page=1&is_resolved=${isResolved}`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getIncidents(env, building, isResolved);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const getIncidentDetail = (env, building, incidentId) => { // Not Used
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/${incidentId}/`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        // eslint-disable-next-line no-undef
        return getIncidentDetail(env, apiLocation);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const getEventDetail = (env, building, incidentId, eventId) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/events/${incidentId}/${eventId}/`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getEventDetail(env, building, incidentId, eventId);
      }
      if (error.response.status === 404) {
        return Promise.reject(error.response.status);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const getIncidentData = (env, apiLocation) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${apiLocation}`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getIncidentData(env, apiLocation);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const getCustomIncidentData = (env, building, dataPoints, startTime, endTime) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(
      `${BASE_URL}/building/api/tracking/${building}/alert-data/?data_points=${dataPoints}&start_datetime=${startTime}&end_datetime=${endTime}`,
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      },
    )
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getCustomIncidentData(env, building, dataPoints, startTime, endTime);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const postComment = (env, apiLocation, comment) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .post(
      `${BASE_URL}${apiLocation}`,
      {
        comment,
      },
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      },
    )
    // eslint-disable-next-line no-unused-vars
    .then((response) => {
      return true;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return postComment(env, apiLocation, comment);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const getAlertsCount = (env) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_ALERTS_ENDPOINT}/alert-count/`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return getAlertsCount(env);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const snoozeAlert = (env, alert_id, snooze_time = 0) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .put(
      `${BASE_URL}${ALERTS_FOLLOWERS_ENDPOINT}${alert_id}/snooze/`,
      {
        alert_uid_hash: alert_id,
        snooze_hours: snooze_time,
      },
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      },
    )
    .then(() => {
      return true;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return snoozeAlert(env, alert_id, snooze_time);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const getAlertPreferencesList = (env, building) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);
    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${ALERTS_FOLLOWERS_ENDPOINT}${building}/preferences/`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);
        return getAlertPreferencesList(env, building);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const updateSpecificAlertPreferences = (env, building, uidHash, subscription, type) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .put(
      `${BASE_URL}${ALERTS_FOLLOWERS_ENDPOINT}${building}/preferences/${uidHash}/`,
      {
        subscribe_to: subscription,
        subscription_type: type,
      },
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      },
    )
    .then(() => {
      return true;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return updateSpecificAlertPreferences(env, building, uidHash, subscription, type);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const updateAllAlertPreferences = (env, building, subscription, type) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .put(
      `${BASE_URL}${ALERTS_FOLLOWERS_ENDPOINT}${building}/preferences/bulk-change/`,
      {
        subscribe_to: subscription,
        subscription_type: type,
      },
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      },
    )
    .then(() => {
      return true;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return updateAllAlertPreferences(env, building, subscription, type);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const getAlertResolutionsList = (env, isUserCreated) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);
    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCIDENTS_ENDPOINT}resolutions/?is_user_created=${isUserCreated}`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);
        return getAlertResolutionsList(env, isUserCreated);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

// Includes adding, updating and deleting alert resolutions
export const updateAlertResolutions = (env, building, incidentUidHash, uidHash, resolutions) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);

    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .patch(
      `${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/events/${incidentUidHash}/${uidHash}/`,
      { resolutions },
      {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      },
    )
    .then(() => {
      return true;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);

        return updateAlertResolutions(env, building, incidentUidHash, uidHash, resolutions);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const getEventsList = (env, building, filters = {}) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);
    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  let filtersUrl = '?page_size=12';

  // Appending the filters to the URL if there are any
  if (Object.keys(filters).length > 0) {
    Object.keys(filters).forEach((filterName) => {
      filtersUrl += `&${filterName}=${filters[ filterName ]}`;
    });
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/events/${filtersUrl}`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);
        return getEventsList(env, building, filters);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};

export const getEventFilterOptions = (env, building) => {
  const BASE_URL = getBaseUrl(env);
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    refreshToken(env);
    authToken = JSON.parse(sessionStorage.getItem('token')) || '';
  }

  const response = axios
    .get(`${BASE_URL}${GET_INCIDENTS_ENDPOINT}${building}/events/filter-options/`, {
      headers: {
        Authorization: `JWT ${authToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch(async (error) => {
      if (error.response.status === 401) {
        refreshToken(env);
        return getEventFilterOptions(env, building);
      }
      return Promise.reject(error.response.data.errors[ 0 ].message);
    });

  return response;
};
